<template>
  <v-app id="enroll">
    <v-content class="white">
      <div id="custom-wrapper">
        <v-container>
          <v-row align="center" justify="center" class="pa-5 mb-0 pb-0">
            <v-col cols="12">
              <v-card class="pattern-bg pa-5 mx-3 text-dark" v-bind:class="{ 'primary--text': 'red' }">
                {{'Er is iets mis gegaan... '}}
              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mb-10">
<!--            <img src="@/assets/success.gif" style="height:61vh"/>-->
          </v-row>
        </v-container>
        <v-container style="text-align: center; font-size: 18px;">
          Er is helaas iets mis gegaan met uw betaling
        </v-container>
      </div>
    </v-content>
  </v-app>
</template>

<script>

export default {};
</script>
<style src="../Status/Status.scss" scoped lang="scss"></style>

